"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardSection = _styledComponents.default.div.withConfig({
  displayName: "CardSection",
  componentId: "sc-1dikwyl-0"
})(["border-bottom:", ";padding:", ";"], function (_ref) {
  var theme = _ref.theme,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? "1px solid ".concat((0, _helpers.color)('dark-3')({
    theme: theme
  })) : _ref$border;
  return border;
}, function (_ref2) {
  var _ref2$spacing = _ref2.spacing,
      spacing = _ref2$spacing === void 0 ? 'medium' : _ref2$spacing;
  return (0, _helpers.getSpacing)(spacing);
});

var _default = CardSection;
exports.default = _default;